export interface InteriorRoomType {
    id: string;
    name: string;
    description: string;
    icon: string;
    defaultFurniture: string[];
    typicalDoors: number;
    typicalWindows: number;
    spatialCharacteristics: string;
    functionalZones: string[];
}

export const INTERIOR_ROOM_TYPES: InteriorRoomType[] = [
    {
        id: 'living_room',
        name: 'Living Room',
        description: 'Main family gathering space for relaxation and entertainment',
        icon: '🛋️',
        defaultFurniture: ['Sofa', 'Coffee Table', 'Armchairs', 'Media Console', 'Bookshelves'],
        typicalDoors: 2,
        typicalWindows: 3,
        spatialCharacteristics: 'Open plan, centered around seating arrangement, focal point (fireplace/TV)',
        functionalZones: ['Seating Area', 'Entertainment Zone', 'Conversation Space']
    },
    {
        id: 'kitchen',
        name: 'Kitchen',
        description: 'Food preparation and cooking area',
        icon: '🍳',
        defaultFurniture: ['Kitchen Island', 'Cabinetry', 'Dining Table', 'Bar Stools', 'Pantry'],
        typicalDoors: 2,
        typicalWindows: 2,
        spatialCharacteristics: 'Work triangle (sink, stove, refrigerator), efficient workflow, storage optimization',
        functionalZones: ['Prep Area', 'Cooking Zone', 'Cleaning Station', 'Dining Space']
    },
    {
        id: 'bedroom',
        name: 'Bedroom',
        description: 'Sleeping quarters and personal retreat',
        icon: '🛏️',
        defaultFurniture: ['Bed', 'Nightstands', 'Wardrobe', 'Dresser', 'Seating'],
        typicalDoors: 1,
        typicalWindows: 2,
        spatialCharacteristics: 'Centered around bed, calm atmosphere, storage for personal items',
        functionalZones: ['Sleeping Area', 'Dressing Zone', 'Reading Nook', 'Storage Space']
    },
    {
        id: 'bathroom',
        name: 'Bathroom',
        description: 'Personal hygiene and grooming space',
        icon: '🚿',
        defaultFurniture: ['Vanity', 'Toilet', 'Shower/Tub', 'Storage Cabinets', 'Mirror'],
        typicalDoors: 1,
        typicalWindows: 1,
        spatialCharacteristics: 'Wet/dry zones, efficient layout, moisture-resistant materials',
        functionalZones: ['Grooming Area', 'Shower/Bath Zone', 'Toilet Enclosure', 'Storage']
    },
    {
        id: 'office',
        name: 'Home Office',
        description: 'Workspace for productivity and concentration',
        icon: '💼',
        defaultFurniture: ['Desk', 'Office Chair', 'Bookshelves', 'Filing Cabinet', 'Task Lighting'],
        typicalDoors: 1,
        typicalWindows: 2,
        spatialCharacteristics: 'Ergonomic setup, organized storage, minimal distractions',
        functionalZones: ['Workstation', 'Meeting Area', 'Storage/Archives', 'Break Space']
    },
    {
        id: 'dining_room',
        name: 'Dining Room',
        description: 'Formal or informal dining space',
        icon: '🍽️',
        defaultFurniture: ['Dining Table', 'Chairs', 'Sideboard', 'China Cabinet', 'Lighting Fixture'],
        typicalDoors: 1,
        typicalWindows: 3,
        spatialCharacteristics: 'Centered around dining table, comfortable circulation space',
        functionalZones: ['Dining Area', 'Serving Space', 'Display Area']
    },
    {
        id: 'study',
        name: 'Study/Library',
        description: 'Quiet space for reading and contemplation',
        icon: '📚',
        defaultFurniture: ['Reading Chair', 'Bookshelves', 'Desk', 'Side Table', 'Floor Lamp'],
        typicalDoors: 1,
        typicalWindows: 2,
        spatialCharacteristics: 'Cozy atmosphere, abundant natural light, organized storage',
        functionalZones: ['Reading Corner', 'Study Area', 'Book Storage', 'Display Space']
    }
];

export const DEFAULT_ROOM_TYPE_ID = 'living_room';